/**
 * React Router Main Entry Point
 */

import { createRoot } from "react-dom/client";
import { useEffect, useState } from "react";
import App from "./App";
import "../ui/styles/globals.css";
import "../utils/extensions";
import { useStore } from "../state/store";
import { runBootstrap } from "@/app/module_api";
import { ErrorBoundary } from "../ui/components/ErrorBoundary";
import { initDebugAPI } from "@/services/debug";

console.log("[main-react-router] starting app");
initDebugAPI();

const RootWithBootstrap = () => {
  const apiToken = useStore((state) => state.apiToken);
  const [bootstrapError, setBootstrapError] = useState<string | null>(null);

  useEffect(() => {
    runBootstrap(apiToken).catch((err) => {
      const message = err instanceof Error ? err.message : "Unknown bootstrap error";
      setBootstrapError(message);
      console.error("[main-react-router] bootstrap failed", err);
    });
  }, [apiToken]);

  if (bootstrapError) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          textAlign: "center",
          background: "#0f172a",
          color: "#e2e8f0",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <div>
          <h1 style={{ marginBottom: "0.75rem" }}>Startup configuration error</h1>
          <p style={{ margin: 0, opacity: 0.9 }}>{bootstrapError}</p>
        </div>
      </div>
    );
  }

  return <App />;
};

const root = createRoot(document.getElementById("app")!);
root.render(
  <ErrorBoundary>
    <RootWithBootstrap />
  </ErrorBoundary>,
);

console.log("[main-react-router] app rendered");
if (window.localStorage) {
  console.log("[main-react-router] stored apiToken?", !!localStorage.getItem("apiToken"));
  console.log("[main-react-router] stored communityToken?", !!localStorage.getItem("communityToken"));
}

declare global {
  interface Window {
    Sentry: any;
  }
}
